(function () {
  var roots = document.querySelectorAll('[data-fp-find]');
  if (!roots.length || window.__fpFindParts) return;
  window.__fpFindParts = true;

  var indexPromise = null;

  function unique(list) {
    var seen = {};
    return list.filter(function (item) {
      if (!item || seen[item]) return false;
      seen[item] = true;
      return true;
    });
  }

  function byName(a, b) {
    return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
  }

  var CATALOG_CACHE = 'fp-fitment-catalog-v1';
  var INDEX_CACHE = 'fp-fitment-index-v1';
  var CACHE_TTL = 12 * 60 * 60 * 1000;

  function readCache(key) {
    try {
      var data = JSON.parse(localStorage.getItem(key) || '');
      if (!data || !Array.isArray(data.items) || !data.savedAt) return null;
      if (Date.now() - data.savedAt > CACHE_TTL) return null;
      return data.items;
    } catch (error) {
      return null;
    }
  }

  function writeCache(key, items) {
    try {
      localStorage.setItem(key, JSON.stringify({ savedAt: Date.now(), items: items }));
    } catch (error) {}
  }

  function usable(item) {
    return item && item.brand && item.yearFrom && item.yearTo && item.yearTo >= item.yearFrom;
  }

  async function fetchPage(url, page) {
    var joiner = url.indexOf('?') === -1 ? '?' : '&';
    var response = await fetch(url + joiner + 'page=' + page, { credentials: 'same-origin' });
    var text = await response.text();
    var start = text.indexOf('{');
    var end = text.lastIndexOf('}');
    if (!response.ok || start < 0 || end < start) throw new Error('fitment unavailable');
    return JSON.parse(text.slice(start, end + 1));
  }

  async function loadPages(url) {
    var first = await fetchPage(url, 1);
    var pages = Math.min(Number(first.pages) || 1, 30);
    var jobs = [];
    for (var page = 2; page <= pages; page += 1) jobs.push(fetchPage(url, page));
    var settled = await Promise.allSettled(jobs);
    var items = Array.isArray(first.items) ? first.items.slice() : [];
    settled.forEach(function (result) {
      if (result.status === 'fulfilled' && Array.isArray(result.value.items)) {
        items = items.concat(result.value.items);
      }
    });
    return items.filter(usable);
  }

  function loadCatalog(url) {
    if (indexPromise) return indexPromise;
    indexPromise = loadPages(url).then(function (items) {
      writeCache(CATALOG_CACHE, items);
      return items;
    }).catch(function () {
      indexPromise = null;
      return readCache(CATALOG_CACHE) || [];
    });
    return indexPromise;
  }

  function loadFullIndex(url) {
    if (window.__fpFitmentPromise) return window.__fpFitmentPromise;
    var pending = loadPages(url).then(function (items) {
      writeCache(INDEX_CACHE, items);
      return items;
    }).catch(function () {
      window.__fpFitmentPromise = null;
      return readCache(INDEX_CACHE) || [];
    });
    window.__fpFitmentPromise = pending;
    return pending;
  }

  function covers(item, year) {
    var yearNum = parseInt(year, 10);
    return yearNum >= item.yearFrom && yearNum <= item.yearTo;
  }

  function yearsFor(items) {
    var years = [];
    items.forEach(function (item) {
      for (var year = item.yearFrom; year <= item.yearTo; year += 1) years.push(String(year));
    });
    return unique(years).sort(function (a, b) { return Number(b) - Number(a); });
  }

  function makesFor(items, year) {
    return unique(items.filter(function (item) {
      return covers(item, year);
    }).map(function (item) {
      return item.brand;
    })).sort(byName);
  }

  function modelsFor(items, year, make) {
    var models = [];
    items.forEach(function (item) {
      if (item.brand !== make || !covers(item, year)) return;
      (item.models || []).forEach(function (model) {
        var clean = String(model || '').trim();
        if (clean) models.push(clean);
      });
    });
    return unique(models).sort(byName);
  }

  function enginesFor(items, year, make, model) {
    var engines = [];
    items.forEach(function (item) {
      if (item.brand !== make || !covers(item, year) || !item.engine) return;
      if (model && (item.models || []).map(function (entry) { return String(entry).trim(); }).indexOf(model) === -1) return;
      engines.push(String(item.engine).trim());
    });
    return unique(engines).sort(byName);
  }

  function fillSelect(select, values, placeholder, selected) {
    var list = values.slice();
    if (selected && list.indexOf(selected) === -1) list.push(selected);
    select.innerHTML = '';
    var first = document.createElement('option');
    first.value = '';
    first.textContent = placeholder;
    select.appendChild(first);
    list.forEach(function (value) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });
    select.value = selected && list.indexOf(selected) !== -1 ? selected : '';
    select.disabled = list.length === 0;
  }

  function readParams() {
    var params = new URLSearchParams(window.location.search);
    return {
      year: params.get('fp_year') || '',
      make: params.get('fp_make') || '',
      model: params.get('fp_model') || '',
      engine: params.get('fp_engine') || ''
    };
  }

  function writeParams(url, params) {
    [
      ['fp_year', params.year],
      ['fp_make', params.make],
      ['fp_model', params.model],
      ['fp_engine', params.engine]
    ].forEach(function (entry) {
      if (entry[1]) url.searchParams.set(entry[0], entry[1]);
      else url.searchParams.delete(entry[0]);
    });
  }

  function searchQuery() {
    return String(new URLSearchParams(window.location.search).get('q') || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function containsQuery(value, query) {
    return String(value || '').trim().toLowerCase().indexOf(query) !== -1;
  }

  function displayModel(make, model) {
    var clean = String(model || '').trim();
    var prefix = String(make || '').trim();
    if (prefix && clean.toLowerCase().indexOf(prefix.toLowerCase()) === 0) {
      clean = clean.slice(prefix.length).replace(/^[\s\-–—]+/, '').trim();
    }
    return clean;
  }

  function yearLabel(entry) {
    if (!entry.yearFrom || !entry.yearTo) return '';
    if (entry.yearFrom === entry.yearTo) return String(entry.yearFrom);
    return entry.yearFrom + '-' + entry.yearTo;
  }

  function matchCard(href, kicker, title) {
    var link = document.createElement('a');
    link.className = 'fp-search-matches__card';
    link.href = href;
    var copy = document.createElement('span');
    copy.className = 'fp-search-matches__copy';
    if (kicker) {
      var small = document.createElement('span');
      small.className = 'fp-search-matches__kicker';
      small.textContent = kicker;
      copy.appendChild(small);
    }
    var strong = document.createElement('span');
    strong.className = 'fp-search-matches__title';
    strong.textContent = title;
    copy.appendChild(strong);
    link.appendChild(copy);
    return link;
  }

  function categoryCard(collection) {
    var link = matchCard(collection.url, collection.parent && collection.parent !== collection.title ? collection.parent : '', collection.title);
    link.classList.add('fp-search-matches__card--series');
    var image = document.createElement('span');
    image.className = 'fp-search-matches__image';
    if (collection.image) {
      var img = document.createElement('img');
      img.src = collection.image;
      img.alt = collection.title;
      image.appendChild(img);
    }
    link.insertBefore(image, link.firstChild);
    return link;
  }

  function renderSearchMatches(root, items) {
    var matches = root.previousElementSibling;
    if (!matches || !matches.hasAttribute('data-fp-search-matches')) return;
    var productsEl = matches.querySelector('[data-fp-search-products]');
    var vehicleSeriesEl = matches.querySelector('[data-fp-search-vehicle-series]');
    var vehiclesEl = matches.querySelector('[data-fp-search-vehicles]');
    var productGrid = matches.querySelector('[data-fp-search-product-grid]');
    var vehicleSeriesGrid = matches.querySelector('[data-fp-search-vehicle-series-grid]');
    var vehicleGrid = matches.querySelector('[data-fp-search-vehicle-grid]');
    var readyEl = matches.querySelector('[data-fp-search-ready]');
    var loadingEl = matches.querySelector('[data-fp-search-loading]');
    if (!productsEl || !vehicleSeriesEl || !vehiclesEl || !productGrid || !vehicleSeriesGrid || !vehicleGrid || !readyEl) return;
    var query = searchQuery();
    productGrid.textContent = '';
    vehicleSeriesGrid.textContent = '';
    vehicleGrid.textContent = '';
    if (loadingEl) loadingEl.remove();
    if (query.length < 2) {
      matches.hidden = true;
      return;
    }

    var seenSeries = {};
    var productSeries = [];
    var vehicleSeries = [];
    var seenBrands = {};
    var brands = [];
    var models = {};
    items.forEach(function (item) {
      (item.collections || []).forEach(function (collection) {
        if (!collection || !collection.handle || !collection.title || seenSeries[collection.handle]) return;
        var seriesType = String(collection.seriesType || '').toLowerCase();
        if (seriesType !== 'product' && seriesType !== 'vehicle') return;
        if (!containsQuery(collection.title, query)) return;
        seenSeries[collection.handle] = true;
        if (seriesType === 'product') productSeries.push(collection);
        else vehicleSeries.push(collection);
      });
      if (item.brand && containsQuery(item.brand, query) && !seenBrands[item.brand]) {
        seenBrands[item.brand] = true;
        brands.push(item.brand);
      }
      (item.models || []).forEach(function (model) {
        var raw = String(model || '').trim();
        if (!raw || !containsQuery(raw, query)) return;
        var key = item.brand + '\n' + raw;
        var entry = models[key];
        if (!entry) {
          models[key] = { make: item.brand, model: raw, yearFrom: item.yearFrom, yearTo: item.yearTo };
          return;
        }
        if (item.yearFrom && (!entry.yearFrom || item.yearFrom < entry.yearFrom)) entry.yearFrom = item.yearFrom;
        if (item.yearTo && item.yearTo > entry.yearTo) entry.yearTo = item.yearTo;
      });
    });

    productSeries.sort(function (a, b) { return byName(a.title, b.title); });
    vehicleSeries.sort(function (a, b) { return byName(a.title, b.title); });
    brands.sort(byName);
    var modelCards = Object.keys(models).map(function (key) { return models[key]; }).filter(function (entry) {
      return displayModel(entry.make, entry.model);
    });
    modelCards.sort(function (a, b) {
      return byName(a.make, b.make) || byName(displayModel(a.make, a.model), displayModel(b.make, b.model));
    });

    productSeries.slice(0, 12).forEach(function (collection) {
      productGrid.appendChild(categoryCard(collection));
    });
    vehicleSeries.slice(0, 12).forEach(function (collection) {
      vehicleSeriesGrid.appendChild(categoryCard(collection));
    });
    brands.slice(0, 12).forEach(function (brand) {
      var url = new URL(root.getAttribute('data-hub-url'), window.location.origin);
      url.searchParams.set('fp_make', brand);
      vehicleGrid.appendChild(matchCard(url.toString(), '', brand));
    });
    modelCards.slice(0, 12).forEach(function (entry) {
      var url = new URL(root.getAttribute('data-hub-url'), window.location.origin);
      url.searchParams.set('fp_make', entry.make);
      url.searchParams.set('fp_model', entry.model);
      var title = displayModel(entry.make, entry.model);
      var years = yearLabel(entry);
      if (years) title += ' ' + years;
      vehicleGrid.appendChild(matchCard(url.toString(), entry.make, title));
    });

    productsEl.hidden = productGrid.childElementCount === 0;
    vehicleSeriesEl.hidden = vehicleSeriesGrid.childElementCount === 0;
    vehiclesEl.hidden = vehicleGrid.childElementCount === 0;
    var empty = productsEl.hidden && vehicleSeriesEl.hidden && vehiclesEl.hidden;
    readyEl.hidden = empty;
    matches.hidden = empty;
  }

  function filterProducts(params) {
    var active = Boolean(params.year || params.make || params.model || params.engine);
    document.querySelectorAll('[data-fp-product-list] [data-fp-product]').forEach(function (card) {
      if (!active) {
        card.classList.remove('fp-find-hidden');
        return;
      }
      var visible = false;
      if (card.hasAttribute('data-fp-fitment')) {
        visible = true;
        if (params.make && card.getAttribute('data-fp-brand') !== params.make) visible = false;
        if (visible && params.year && !covers({
          yearFrom: parseInt(card.getAttribute('data-fp-year-from'), 10),
          yearTo: parseInt(card.getAttribute('data-fp-year-to'), 10)
        }, params.year)) visible = false;
        if (visible && params.model) {
          var models = String(card.getAttribute('data-fp-models') || '').split('|');
          if (models.indexOf(params.model) === -1) visible = false;
        }
        if (visible && params.engine && card.getAttribute('data-fp-engine') !== params.engine) visible = false;
      }
      card.classList.toggle('fp-find-hidden', !visible);
    });
  }

  roots.forEach(function (root) {
    var yearSelect = root.querySelector('[data-fp-year]');
    var makeSelect = root.querySelector('[data-fp-make]');
    var modelSelect = root.querySelector('[data-fp-model]');
    var engineSelect = root.querySelector('[data-fp-engine]');
    var submit = root.querySelector('[data-fp-submit]');
    var clear = root.querySelector('[data-fp-clear]');
    var vehicleBar = root.nextElementSibling && root.nextElementSibling.hasAttribute('data-fp-vehicle-bar')
      ? root.nextElementSibling
      : null;
    var items = [];
    var saved = readParams();
    if (root.getAttribute('data-fp-context') === 'search' && searchQuery().length < 2) {
      var earlyMatches = root.previousElementSibling;
      if (earlyMatches && earlyMatches.hasAttribute('data-fp-search-matches')) earlyMatches.hidden = true;
    }

    function current() {
      return {
        year: yearSelect.value,
        make: makeSelect.value,
        model: modelSelect.value,
        engine: engineSelect ? engineSelect.value : ''
      };
    }

    function refreshSubmit() {
      var ready = Boolean(yearSelect.value && makeSelect.value);
      submit.disabled = !ready;
      submit.classList.toggle('is-ready', ready);
    }

    function clearYearLoading() {
      yearSelect.classList.remove('is-loading');
      yearSelect.removeAttribute('aria-busy');
      var slot = yearSelect.closest('.fp-find__slot');
      if (slot) slot.classList.remove('is-loading');
    }

    function paint(selected) {
      clearYearLoading();
      fillSelect(yearSelect, yearsFor(items), 'Year', selected.year);
      var makes = selected.year ? makesFor(items, selected.year) : [];
      fillSelect(makeSelect, makes, 'Make', selected.make);
      var models = selected.year && selected.make ? modelsFor(items, selected.year, selected.make) : [];
      fillSelect(modelSelect, models, 'Model', selected.model);
      makeSelect.disabled = !yearSelect.value || makes.length === 0;
      modelSelect.disabled = !makeSelect.value || models.length === 0;
      if (engineSelect) {
        var engines = selected.year && selected.make && selected.model
          ? enginesFor(items, selected.year, selected.make, selected.model)
          : [];
        fillSelect(engineSelect, engines, 'Engine', selected.engine);
        engineSelect.disabled = !modelSelect.value || engines.length === 0;
      }
      refreshSubmit();
    }

    function lockSelect(select, value) {
      if (!select || !value) return;
      var option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
      select.value = value;
      select.disabled = true;
    }

    function lockSaved(params) {
      if (root.getAttribute('data-fp-context') === 'home') return;
      if (!(params.year || params.make || params.model || params.engine)) return;
      lockSelect(yearSelect, params.year);
      lockSelect(makeSelect, params.make);
      lockSelect(modelSelect, params.model);
      if (engineSelect) lockSelect(engineSelect, params.engine);
      refreshSubmit();
    }

    function finishPending() {
      document.documentElement.classList.remove('fp-find-pending');
    }

    function paintVehicle(params) {
      if (!vehicleBar) return;
      var parts = [params.year, params.make, params.model, params.engine].filter(Boolean);
      var text = vehicleBar.querySelector('[data-fp-vehicle-text]');
      if (!parts.length) {
        vehicleBar.hidden = true;
        if (text) text.textContent = '';
        return;
      }
      if (text) text.textContent = 'Vehicle: ' + parts.join(' ');
      vehicleBar.hidden = false;
    }

    function clearVehicle() {
      go({ year: '', make: '', model: '', engine: '' });
    }

    function go(params) {
      var hasVehicle = Boolean(params.year || params.make || params.model || params.engine);
      var context = root.getAttribute('data-fp-context');
      var url = new URL(window.location.href);
      if (context === 'home') {
        if (!hasVehicle) {
          paint({ year: '', make: '', model: '', engine: '' });
          return;
        }
        url = new URL(root.getAttribute('data-hub-url'), window.location.origin);
      } else if ((context === 'collection' || context === 'search') && hasVehicle) {
        url = new URL(root.getAttribute('data-results-url'), window.location.origin);
      }
      writeParams(url, params);
      window.location.assign(url.toString());
    }

    yearSelect.addEventListener('change', function () {
      paint({ year: yearSelect.value, make: '', model: '', engine: '' });
    });
    makeSelect.addEventListener('change', function () {
      paint({ year: yearSelect.value, make: makeSelect.value, model: '', engine: '' });
    });
    modelSelect.addEventListener('change', function () {
      paint({ year: yearSelect.value, make: makeSelect.value, model: modelSelect.value, engine: '' });
    });
    if (engineSelect) engineSelect.addEventListener('change', refreshSubmit);
    submit.addEventListener('click', function () {
      if (submit.disabled) return;
      go(current());
    });
    clear.addEventListener('click', function () {
      var params = readParams();
      if (params.year || params.make || params.model || params.engine) {
        clearVehicle();
        return;
      }
      paint({ year: '', make: '', model: '', engine: '' });
      filterProducts(current());
    });
    if (vehicleBar) {
      vehicleBar.querySelector('[data-fp-vehicle-remove]').addEventListener('click', clearVehicle);
      vehicleBar.querySelector('[data-fp-vehicle-clear]').addEventListener('click', clearVehicle);
      paintVehicle(saved);
    }
    lockSaved(saved);

    var cachedCatalog = readCache(CATALOG_CACHE);
    if (cachedCatalog && cachedCatalog.length) {
      items = cachedCatalog;
      paint(saved);
      clearYearLoading();
    }

    loadCatalog(root.getAttribute('data-catalog-url') || root.getAttribute('data-index-url')).then(function (list) {
      try {
        items = list || [];
        paint(current());
        if (root.getAttribute('data-fp-context') !== 'home') filterProducts(current());
      } finally {
        clearYearLoading();
        finishPending();
      }
      if (root.getAttribute('data-fp-context') === 'search') {
        var cachedIndex = readCache(INDEX_CACHE);
        if (cachedIndex && cachedIndex.length) renderSearchMatches(root, cachedIndex);
        loadFullIndex(root.getAttribute('data-index-url')).then(function (full) {
          renderSearchMatches(root, full || []);
        });
      }
    });
  });
})();
